import React from 'react';

const Editorials = () => {
  return (
    <div>
      <h2 className='mt-1 text-lg font-semibold tracking-wide text-gray-600'>Editorials</h2>
    </div>
  );
};

export default Editorials;